import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  getIsScrollToTop,
  selectIsScrollToTop,
} from "../redux/reducers/slice/common";

export default function ScrollToTop() {
  const { pathname, search } = useLocation();
  const isScrollToTop = useSelector(selectIsScrollToTop);
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      pathname.indexOf("/chi-tiet-san-pham/") === -1 &&
      pathname.indexOf("/product-detail/") === -1
    ) {
      window.scrollTo(0, 0);
      dispatch(getIsScrollToTop(0));
    } else {
      if (isScrollToTop === 0) {
        window.scrollTo(0, 0);
        dispatch(getIsScrollToTop(1));
      } else {
        dispatch(getIsScrollToTop(1));
      }
    }
  }, [pathname, search]);

  return null;
}
